module.exports = __webpack_public_path__ + "static/playground-91f43f8b65a306305039b52a76ab0878.jpg";